module.exports = __webpack_public_path__ + "img/skull-reverse.24224503.png";